(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["product-description"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('rc-product-description')) {
  customElements.define('rc-product-description', class extends HTMLElement {
    connectedCallback() {
      this.content = this.querySelector('.product-description-content');
      this.button = this.querySelector('button');
      if (!this.content || !this.button) return;
      this.expanded = false;
      this.measure = () => {
        const height = this.content.scrollHeight;
        const preview = parseFloat(getComputedStyle(this).getPropertyValue('--description-preview')) || 200;
        const collapsible = height > preview + 32;
        this.style.setProperty('--description-height', height + 'px');
        this.toggleAttribute('data-collapsible', collapsible);
        if (collapsible) this.dataset.expanded = String(this.expanded);
        else delete this.dataset.expanded;
        this.button.hidden = !collapsible;
      };
      this.toggle = () => {
        this.expanded = !this.expanded;
        this.dataset.expanded = String(this.expanded);
        this.button.setAttribute('aria-expanded', String(this.expanded));
        this.button.innerHTML = this.expanded ? 'Zwiń opis <span aria-hidden="true">↑</span>' : 'Rozwiń opis <span aria-hidden="true">↓</span>';
      };
      this.button.addEventListener('click', this.toggle);
      this.observer = new ResizeObserver(this.measure);
      this.observer.observe(this.content);
      this.measure();
    }
    disconnectedCallback() {
      this.observer?.disconnect();
      this.button?.removeEventListener('click', this.toggle);
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-info-tabs"] && !Shopify.designMode) return;
  try {
    

if (!customElements.get('rc-product-description')) {
  customElements.define('rc-product-description', class extends HTMLElement {
    connectedCallback() {
      this.content = this.querySelector('.product-description-content');
      this.button = this.querySelector('button');
      if (!this.content || !this.button) return;
      this.expanded = false;
      this.measure = () => {
        const height = this.content.scrollHeight;
        const preview = parseFloat(getComputedStyle(this).getPropertyValue('--description-preview')) || 200;
        const collapsible = height > preview + 32;
        this.style.setProperty('--description-height', height + 'px');
        this.toggleAttribute('data-collapsible', collapsible);
        if (collapsible) this.dataset.expanded = String(this.expanded);
        else delete this.dataset.expanded;
        this.button.hidden = !collapsible;
      };
      this.toggle = () => {
        this.expanded = !this.expanded;
        this.dataset.expanded = String(this.expanded);
        this.button.setAttribute('aria-expanded', String(this.expanded));
        this.button.innerHTML = this.expanded ? 'Zwiń opis <span aria-hidden="true">↑</span>' : 'Rozwiń opis <span aria-hidden="true">↓</span>';
      };
      this.button.addEventListener('click', this.toggle);
      this.observer = new ResizeObserver(this.measure);
      this.observer.observe(this.content);
      this.measure();
    }
    disconnectedCallback() {
      this.observer?.disconnect();
      this.button?.removeEventListener('click', this.toggle);
    }
  });
}

if (!customElements.get('rc-product-info-tabs')) {
  customElements.define('rc-product-info-tabs', class extends HTMLElement {
    connectedCallback() {
      this.tabs = [...this.querySelectorAll('[data-info-tab]')];
      this.panels = [...this.querySelectorAll('[data-info-panel]')];
      this.selectTab = (index, focus = false) => {
        this.tabs.forEach((tab, i) => {
          tab.setAttribute('aria-selected', String(i === index));
          tab.tabIndex = i === index ? 0 : -1;
          const panel = this.panels[i];
          panel.hidden = i !== index;
          panel.setAttribute('role','tabpanel');
          panel.setAttribute('aria-labelledby',tab.id);
          panel.tabIndex = 0;
        });
        if (focus) this.tabs[index].focus();
        const description = this.querySelector('rc-product-description');
        if (index === 0) requestAnimationFrame(() => description?.measure?.());
      };
      this.click = event => {
        const tab = event.target.closest('[data-info-tab]');
        const index = this.tabs.indexOf(tab);
        if (index >= 0) this.selectTab(index);
      };
      this.key = event => {
        const index = this.tabs.indexOf(event.target);
        if (index < 0 || !['ArrowLeft','ArrowRight','Home','End'].includes(event.key)) return;
        event.preventDefault();
        const next = event.key === 'Home' ? 0 : event.key === 'End' ? this.tabs.length - 1 : (index + (event.key === 'ArrowRight' ? 1 : -1) + this.tabs.length) % this.tabs.length;
        this.selectTab(next,true);
      };
      this.variants = JSON.parse(this.querySelector('[data-info-variants]')?.textContent || '[]');
      this.variantChange = event => {
        if (!event.target.matches('[data-variant-select]')) return;
        const form = event.target.closest('form');
        if (form?.querySelector('[name="product-id"]')?.value && form.querySelector('[name="product-id"]').value !== this.dataset.product) return;
        const variant = this.variants.find(v => String(v.id) === event.target.value);
        if (!variant) return;
        ['sku','ean','weight'].forEach(key => {
          const row = this.querySelector('[data-spec-row="'+key+'"]');
          const value = this.querySelector('[data-spec-value="'+key+'"]');
          if (row && value) { row.hidden = !variant[key]; value.textContent = variant[key] || ''; }
        });
      };
      this.addEventListener('click',this.click);
      this.addEventListener('keydown',this.key);
      document.addEventListener('change',this.variantChange);
      this.querySelector('.product-info-tabs').hidden = false;
      this.dataset.enhanced = 'true';
      this.selectTab(0);
    }
    disconnectedCallback() {
      this.removeEventListener('click',this.click);
      this.removeEventListener('keydown',this.key);
      document.removeEventListener('change',this.variantChange);
    }
  });
}


  } catch(e) { console.error(e); }
})();
})();
